import React, { useState, useEffect } from "react";
import { MenuItem, Select, FormControl, ListItemText, Checkbox, OutlinedInput } from '@mui/material';
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 280,
    },
  },
};
const Dropdown = (props) => {
  const { formInputsProps } = props
  const [select, setSelectValue] = useState([]);
  const [singleSelect, setSingleSelectValue] = useState("");
  const setSelectBoxConfig = () => {
    return formInputsProps?.formField['type'] == 'multiple_select' ? true : false
  }

  const renderValueCondition = (selected, field) => {
    if ((selected && selected.length === 0) || (field['type'] == "single_select" && !selected)) {
      return <span style={{"fontSize": "14px"}}>Select {formInputsProps?.formField?.input} </span>;
    }
    if (setSelectBoxConfig()) {
      return selected.join(', ');
    }
    return selected
  }

  const renderItem = () => {
    if (setSelectBoxConfig()) {
      return formInputsProps?.formField?.value.map(list => {
        return (
          <MenuItem key={list?.value} value={list?.value}>
            <Checkbox className={formInputsProps.responseData.theme} checked={select.indexOf(list?.value) > -1} />
            <ListItemText primary={list?.key} />
          </MenuItem>
        )

      })
    } else {
      return formInputsProps?.formField?.value.map(list => {
        return (
          <MenuItem key={list?.value} value={list?.value}>{list.key}</MenuItem>
        )

      })
    }


  }

  const handleChange = (e, data) => {
    const { value } = e.target
    // setSelectValue(
    //   typeof value === 'string' ? value.split(',') : value,
    // );
    if(data['type'] == "single_select") {
      setSingleSelectValue(value)
    }
    else {
      setSelectValue(value);
    }
  };

  // useEffect(() => {
  //   if (select) {
  //     formInputsProps.formValues[formInputsProps?.formField?.input] = select
  //   }
  // }, [select])

  return (
    <div className="col-12 form-group">
      <label> {formInputsProps?.formField?.is_mandatory ? '*' : null} {formInputsProps?.formField?.input} </label>
      <FormControl className="width-100" sx = {{ m: 1, minWidth: 300 }}>
        <Select
          labelId = "demo-multiple-checkbox-label"
          id = "demo-multiple-checkbox"
          multiple = {setSelectBoxConfig()}
          value = {formInputsProps.formField?.type == 'single_select' ? formInputsProps.formValues[formInputsProps.formField?.input] = singleSelect : formInputsProps.formValues[formInputsProps.formField?.input] = select}
          displayEmpty
          onChange = {e => handleChange(e, formInputsProps.formField)}
          input = {<OutlinedInput label="Select" />}
          // inputProps = {{ 'aria-label': 'Without label' }}
          renderValue = {e => renderValueCondition(e, formInputsProps.formField)}
          MenuProps = {MenuProps}
        >
          {renderItem()}
        </Select>
      </FormControl>
      
      {
        (select.constructor === Array && !select?.length) ? 
          <p className="errMsg">{formInputsProps.formErrors[formInputsProps.formField?.input]}</p> : 
        null
      }

    </div>
  )
}

export default Dropdown
